import React from 'react';
import { Lightbulb } from 'lucide-react';

interface EmptyStateProps {
  onGenerate: () => void;
  isGenerating: boolean;
}

export const EmptyState: React.FC<EmptyStateProps> = ({ onGenerate, isGenerating }) => {
  return (
    <div className="min-h-[600px] flex items-center justify-center px-4">
      <div className="text-center max-w-md">
        {/* Icon */}
        <div
          className="w-20 h-20 rounded-2xl flex items-center justify-center mx-auto mb-6"
          style={{ backgroundColor: 'color-mix(in oklab, var(--accent) 12%, white)' }}
        >
          <Lightbulb className="w-10 h-10" style={{ color: 'var(--accent)' }} />
        </div>

        {/* Title */}
        <h2 className="text-2xl font-semibold text-slate-900 mb-3">
          Create Instructions
        </h2>

        {/* Description */}
        <p className="text-slate-600 mb-8 leading-relaxed">
          Generate AI-powered instructions based on your project specification document
        </p>

        {/* Generate Button */}
        <button
          onClick={onGenerate}
          disabled={isGenerating}
          className={`
            px-8 py-3.5 
            text-white 
            rounded-lg font-medium
            active:scale-[0.98]
            transition-all duration-150
            focus:outline-none focus:ring-2 focus:ring-[var(--focus-ring)] focus:ring-offset-2
            disabled:opacity-50 disabled:cursor-not-allowed
            ${isGenerating ? 'cursor-wait' : ''}
          `}
          style={{ backgroundColor: 'var(--accent)' }}
          onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = 'var(--accent-hover)')}
          onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = 'var(--accent)')}
        >
          {isGenerating ? (
            <span className="flex items-center">
              <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
              Creating Instructions...
            </span>
          ) : (
            'Create Instructions'
          )}
        </button>
      </div>
    </div>
  );
};